import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-audit-trail-auth",
  templateUrl: "./audit-trail-auth.component.html",
  styleUrls: ["./audit-trail-auth.component.scss"],
})
export class AuditTrailAuthComponent {
  constructor(private router: Router) {}

  transferAuditDetails() {
    this.router.navigate([
      "digital-identity/auth-tools/audit-trail-auth/transfer-view",
    ]);
  }
  terminationAuditDetails() {
    this.router.navigate([
      "digital-identity/auth-tools/audit-trail-auth/termination-view",
    ]);
  }
}
